// removed by extract-text-webpack-plugin
module.exports = {"bhvfin":"_2v2_wpxS1OXm0Yxf1b7fE2","headerRow":"_3ky7PveWbcWVuFuKgGfhZk","headerTitle":"_26yZy2K8nKfpIgAeSsBBTa","addClient":"_4CK8kS413ZDlok_5FNDio","addClientText":"_1ZgvE6yQbiBiFmiBtNOM-h","addClientIcon":"dXz6pYe-lOPEzMR9w2_2y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/AdvisorMode.css
// module id = 813
// module chunks = 0